import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePracticeDetails = () => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["practicedetails", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/practicedetails`);
      return response.data;
    },
    enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching practice details" },
  });
};
